module.exports = __webpack_public_path__ + "images/interview-Intel_Corporation-2.svg";